/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardClubDetail,
  DashboardClubList,
  DashboardClubListItem,
  DashboardClubMemberList,
  DashboardClubMemberStats,
  DashboardClubMemberStatusUpdate,
  DashboardClubMemberStatusUpdateInput,
  DashboardClubRef,
  DashboardClubSearchList,
  DashboardClubStatusUpdate,
  DashboardClubsAttachPlatform,
  DashboardClubsControllerAttachToPlatform400,
  DashboardClubsControllerAttachToPlatform401,
  DashboardClubsControllerAttachToPlatform403,
  DashboardClubsControllerAttachToPlatform404,
  DashboardClubsControllerAttachToPlatform409,
  DashboardClubsControllerAttachToPlatform429,
  DashboardClubsControllerDetachFromPlatform400,
  DashboardClubsControllerDetachFromPlatform401,
  DashboardClubsControllerDetachFromPlatform403,
  DashboardClubsControllerDetachFromPlatform404,
  DashboardClubsControllerDetachFromPlatform409,
  DashboardClubsControllerDetachFromPlatform429,
  DashboardClubsControllerDetail400,
  DashboardClubsControllerDetail401,
  DashboardClubsControllerDetail404,
  DashboardClubsControllerDetail429,
  DashboardClubsControllerExport400,
  DashboardClubsControllerExport401,
  DashboardClubsControllerExport413,
  DashboardClubsControllerExport429,
  DashboardClubsControllerExportParams,
  DashboardClubsControllerList400,
  DashboardClubsControllerList401,
  DashboardClubsControllerList429,
  DashboardClubsControllerListParams,
  DashboardClubsControllerMemberList400,
  DashboardClubsControllerMemberList401,
  DashboardClubsControllerMemberList404,
  DashboardClubsControllerMemberList429,
  DashboardClubsControllerMemberListParams,
  DashboardClubsControllerMembersStats400,
  DashboardClubsControllerMembersStats401,
  DashboardClubsControllerMembersStats404,
  DashboardClubsControllerMembersStats429,
  DashboardClubsControllerRefs400,
  DashboardClubsControllerRefs401,
  DashboardClubsControllerRefs429,
  DashboardClubsControllerRefsParams,
  DashboardClubsControllerSearch400,
  DashboardClubsControllerSearch401,
  DashboardClubsControllerSearch429,
  DashboardClubsControllerSearchParams,
  DashboardClubsControllerUpdateMemberStatus400,
  DashboardClubsControllerUpdateMemberStatus401,
  DashboardClubsControllerUpdateMemberStatus404,
  DashboardClubsControllerUpdateMemberStatus429,
  DashboardClubsControllerUpdateStatus400,
  DashboardClubsControllerUpdateStatus401,
  DashboardClubsControllerUpdateStatus404,
  DashboardClubsControllerUpdateStatus429,
  DashboardClubsDetachPlatform,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated club list scoped to the caller: the `CLUB:READ` capability universe UNION the legacy accessible sets. `platformIds` and `organizationIds` are pure filters applied together (AND of axes); the platform filter reads the authoritative `(club, federation, platform)` membership pivot — a membership with no platform attribution counts as a wildcard over the platforms its federation is linked to. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Each row includes the slim club summary, the primary organization, accessible platforms, sports, tournaments count, and the member-status breakdown.
 * @summary List clubs (dashboard)
 */
export const dashboardClubsControllerList = (
  params?: DashboardClubsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubList>(
    { url: `/api/dashboard/v1/clubs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardClubsControllerListQueryKey = (
  params?: DashboardClubsControllerListParams
) => {
  return [`/api/dashboard/v1/clubs`, ...(params ? [params] : [])] as const;
};

export const getDashboardClubsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerList>>,
  TError = ErrorType<
    | DashboardClubsControllerList400
    | DashboardClubsControllerList401
    | DashboardClubsControllerList429
  >,
>(
  params?: DashboardClubsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerList>>> = ({
    signal,
  }) => dashboardClubsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerList>>
>;
export type DashboardClubsControllerListQueryError = ErrorType<
  | DashboardClubsControllerList400
  | DashboardClubsControllerList401
  | DashboardClubsControllerList429
>;

export function useDashboardClubsControllerList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerList>>,
  TError = ErrorType<
    | DashboardClubsControllerList400
    | DashboardClubsControllerList401
    | DashboardClubsControllerList429
  >,
>(
  params: undefined | DashboardClubsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerList>>,
  TError = ErrorType<
    | DashboardClubsControllerList400
    | DashboardClubsControllerList401
    | DashboardClubsControllerList429
  >,
>(
  params?: DashboardClubsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerList>>,
  TError = ErrorType<
    | DashboardClubsControllerList400
    | DashboardClubsControllerList401
    | DashboardClubsControllerList429
  >,
>(
  params?: DashboardClubsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List clubs (dashboard)
 */

export function useDashboardClubsControllerList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerList>>,
  TError = ErrorType<
    | DashboardClubsControllerList400
    | DashboardClubsControllerList401
    | DashboardClubsControllerList429
  >,
>(
  params?: DashboardClubsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE).
 * @summary Export clubs (dashboard)
 */
export const dashboardClubsControllerExport = (
  params: DashboardClubsControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    { url: `/api/dashboard/v1/clubs/export`, method: "GET", params, responseType: "blob", signal },
    options
  );
};

export const getDashboardClubsControllerExportQueryKey = (
  params: DashboardClubsControllerExportParams
) => {
  return [`/api/dashboard/v1/clubs/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardClubsControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
  TError = ErrorType<
    | DashboardClubsControllerExport400
    | DashboardClubsControllerExport401
    | DashboardClubsControllerExport413
    | DashboardClubsControllerExport429
  >,
>(
  params: DashboardClubsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerExport>>> = ({
    signal,
  }) => dashboardClubsControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerExport>>
>;
export type DashboardClubsControllerExportQueryError = ErrorType<
  | DashboardClubsControllerExport400
  | DashboardClubsControllerExport401
  | DashboardClubsControllerExport413
  | DashboardClubsControllerExport429
>;

export function useDashboardClubsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
  TError = ErrorType<
    | DashboardClubsControllerExport400
    | DashboardClubsControllerExport401
    | DashboardClubsControllerExport413
    | DashboardClubsControllerExport429
  >,
>(
  params: DashboardClubsControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
  TError = ErrorType<
    | DashboardClubsControllerExport400
    | DashboardClubsControllerExport401
    | DashboardClubsControllerExport413
    | DashboardClubsControllerExport429
  >,
>(
  params: DashboardClubsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
  TError = ErrorType<
    | DashboardClubsControllerExport400
    | DashboardClubsControllerExport401
    | DashboardClubsControllerExport413
    | DashboardClubsControllerExport429
  >,
>(
  params: DashboardClubsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export clubs (dashboard)
 */

export function useDashboardClubsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerExport>>,
  TError = ErrorType<
    | DashboardClubsControllerExport400
    | DashboardClubsControllerExport401
    | DashboardClubsControllerExport413
    | DashboardClubsControllerExport429
  >,
>(
  params: DashboardClubsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated autocomplete-friendly club search. Returns the slim `DashboardClubRef` shape. `requiredCapability=READ` (default) uses the connection-aware `CLUB:READ` pair universe; `WRITE` uses `CLUB:WRITE`; `CREATE` returns clubs whose sole owning federation grants `CLUB:CREATE`. CREATE callers can combine `attachableToPlatformId` with `excludePlatformIds` to show only clubs whose owner is linked to a target platform and which are not attached there yet.
 * @summary Search clubs (dashboard)
 */
export const dashboardClubsControllerSearch = (
  params?: DashboardClubsControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubSearchList>(
    { url: `/api/dashboard/v1/clubs/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardClubsControllerSearchQueryKey = (
  params?: DashboardClubsControllerSearchParams
) => {
  return [`/api/dashboard/v1/clubs/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardClubsControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
  TError = ErrorType<
    | DashboardClubsControllerSearch400
    | DashboardClubsControllerSearch401
    | DashboardClubsControllerSearch429
  >,
>(
  params?: DashboardClubsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>> = ({
    signal,
  }) => dashboardClubsControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerSearch>>
>;
export type DashboardClubsControllerSearchQueryError = ErrorType<
  | DashboardClubsControllerSearch400
  | DashboardClubsControllerSearch401
  | DashboardClubsControllerSearch429
>;

export function useDashboardClubsControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
  TError = ErrorType<
    | DashboardClubsControllerSearch400
    | DashboardClubsControllerSearch401
    | DashboardClubsControllerSearch429
  >,
>(
  params: undefined | DashboardClubsControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
  TError = ErrorType<
    | DashboardClubsControllerSearch400
    | DashboardClubsControllerSearch401
    | DashboardClubsControllerSearch429
  >,
>(
  params?: DashboardClubsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
  TError = ErrorType<
    | DashboardClubsControllerSearch400
    | DashboardClubsControllerSearch401
    | DashboardClubsControllerSearch429
  >,
>(
  params?: DashboardClubsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search clubs (dashboard)
 */

export function useDashboardClubsControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerSearch>>,
  TError = ErrorType<
    | DashboardClubsControllerSearch400
    | DashboardClubsControllerSearch401
    | DashboardClubsControllerSearch429
  >,
>(
  params?: DashboardClubsControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batch lookup of the slim `DashboardClubRef` shape (`id`, `clubName`, `logo`, `city`, `type`) for a known set of ids. Used to rehydrate filter-chip labels from saved client state. Order matches the request; ids the caller cannot resolve (missing or out-of-scope) are silently omitted.
 * @summary Resolve club refs by id (dashboard)
 */
export const dashboardClubsControllerRefs = (
  params: DashboardClubsControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubRef[]>(
    { url: `/api/dashboard/v1/clubs/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardClubsControllerRefsQueryKey = (
  params: DashboardClubsControllerRefsParams
) => {
  return [`/api/dashboard/v1/clubs/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardClubsControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
  TError = ErrorType<
    | DashboardClubsControllerRefs400
    | DashboardClubsControllerRefs401
    | DashboardClubsControllerRefs429
  >,
>(
  params: DashboardClubsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>> = ({
    signal,
  }) => dashboardClubsControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerRefs>>
>;
export type DashboardClubsControllerRefsQueryError = ErrorType<
  | DashboardClubsControllerRefs400
  | DashboardClubsControllerRefs401
  | DashboardClubsControllerRefs429
>;

export function useDashboardClubsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
  TError = ErrorType<
    | DashboardClubsControllerRefs400
    | DashboardClubsControllerRefs401
    | DashboardClubsControllerRefs429
  >,
>(
  params: DashboardClubsControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
  TError = ErrorType<
    | DashboardClubsControllerRefs400
    | DashboardClubsControllerRefs401
    | DashboardClubsControllerRefs429
  >,
>(
  params: DashboardClubsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
  TError = ErrorType<
    | DashboardClubsControllerRefs400
    | DashboardClubsControllerRefs401
    | DashboardClubsControllerRefs429
  >,
>(
  params: DashboardClubsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve club refs by id (dashboard)
 */

export function useDashboardClubsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerRefs>>,
  TError = ErrorType<
    | DashboardClubsControllerRefs400
    | DashboardClubsControllerRefs401
    | DashboardClubsControllerRefs429
  >,
>(
  params: DashboardClubsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attach one or more existing clubs to an additional platform without changing ownership. Every club must have exactly one owning federation, that federation must be linked to the target platform, and the caller must hold `CLUB:CREATE` on every distinct owning federation. Idempotent; returns `204 No Content`.
 * @summary Attach existing clubs to a platform (dashboard)
 */
export const dashboardClubsControllerAttachToPlatform = (
  dashboardClubsAttachPlatform: BodyType<DashboardClubsAttachPlatform>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/clubs/attach-to-platform`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardClubsAttachPlatform,
      signal,
    },
    options
  );
};

export const getDashboardClubsControllerAttachToPlatformMutationOptions = <
  TError = ErrorType<
    | DashboardClubsControllerAttachToPlatform400
    | DashboardClubsControllerAttachToPlatform401
    | DashboardClubsControllerAttachToPlatform403
    | DashboardClubsControllerAttachToPlatform404
    | DashboardClubsControllerAttachToPlatform409
    | DashboardClubsControllerAttachToPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>,
    TError,
    { data: BodyType<DashboardClubsAttachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>,
  TError,
  { data: BodyType<DashboardClubsAttachPlatform> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>,
    { data: BodyType<DashboardClubsAttachPlatform> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardClubsControllerAttachToPlatform(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardClubsControllerAttachToPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>
>;
export type DashboardClubsControllerAttachToPlatformMutationBody =
  BodyType<DashboardClubsAttachPlatform>;
export type DashboardClubsControllerAttachToPlatformMutationError = ErrorType<
  | DashboardClubsControllerAttachToPlatform400
  | DashboardClubsControllerAttachToPlatform401
  | DashboardClubsControllerAttachToPlatform403
  | DashboardClubsControllerAttachToPlatform404
  | DashboardClubsControllerAttachToPlatform409
  | DashboardClubsControllerAttachToPlatform429
>;

/**
 * @summary Attach existing clubs to a platform (dashboard)
 */
export const useDashboardClubsControllerAttachToPlatform = <
  TError = ErrorType<
    | DashboardClubsControllerAttachToPlatform400
    | DashboardClubsControllerAttachToPlatform401
    | DashboardClubsControllerAttachToPlatform403
    | DashboardClubsControllerAttachToPlatform404
    | DashboardClubsControllerAttachToPlatform409
    | DashboardClubsControllerAttachToPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>,
    TError,
    { data: BodyType<DashboardClubsAttachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardClubsControllerAttachToPlatform>>,
  TError,
  { data: BodyType<DashboardClubsAttachPlatform> },
  TContext
> => {
  const mutationOptions = getDashboardClubsControllerAttachToPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Detach one or more clubs from a platform without changing their owning federation. The caller must hold `CLUB:WRITE` on every distinct owning federation. Idempotent; returns `204 No Content`.
 * @summary Detach clubs from a platform (dashboard)
 */
export const dashboardClubsControllerDetachFromPlatform = (
  dashboardClubsDetachPlatform: BodyType<DashboardClubsDetachPlatform>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/clubs/detach-from-platform`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardClubsDetachPlatform,
      signal,
    },
    options
  );
};

export const getDashboardClubsControllerDetachFromPlatformMutationOptions = <
  TError = ErrorType<
    | DashboardClubsControllerDetachFromPlatform400
    | DashboardClubsControllerDetachFromPlatform401
    | DashboardClubsControllerDetachFromPlatform403
    | DashboardClubsControllerDetachFromPlatform404
    | DashboardClubsControllerDetachFromPlatform409
    | DashboardClubsControllerDetachFromPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>,
    TError,
    { data: BodyType<DashboardClubsDetachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>,
  TError,
  { data: BodyType<DashboardClubsDetachPlatform> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>,
    { data: BodyType<DashboardClubsDetachPlatform> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardClubsControllerDetachFromPlatform(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardClubsControllerDetachFromPlatformMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>
>;
export type DashboardClubsControllerDetachFromPlatformMutationBody =
  BodyType<DashboardClubsDetachPlatform>;
export type DashboardClubsControllerDetachFromPlatformMutationError = ErrorType<
  | DashboardClubsControllerDetachFromPlatform400
  | DashboardClubsControllerDetachFromPlatform401
  | DashboardClubsControllerDetachFromPlatform403
  | DashboardClubsControllerDetachFromPlatform404
  | DashboardClubsControllerDetachFromPlatform409
  | DashboardClubsControllerDetachFromPlatform429
>;

/**
 * @summary Detach clubs from a platform (dashboard)
 */
export const useDashboardClubsControllerDetachFromPlatform = <
  TError = ErrorType<
    | DashboardClubsControllerDetachFromPlatform400
    | DashboardClubsControllerDetachFromPlatform401
    | DashboardClubsControllerDetachFromPlatform403
    | DashboardClubsControllerDetachFromPlatform404
    | DashboardClubsControllerDetachFromPlatform409
    | DashboardClubsControllerDetachFromPlatform429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>,
    TError,
    { data: BodyType<DashboardClubsDetachPlatform> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardClubsControllerDetachFromPlatform>>,
  TError,
  { data: BodyType<DashboardClubsDetachPlatform> },
  TContext
> => {
  const mutationOptions = getDashboardClubsControllerDetachFromPlatformMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Single club with contact, social, address, main administrator, organization list, platforms, sports, and coaches (each with a `studentsCount` count).
 * @summary Get club detail (dashboard)
 */
export const dashboardClubsControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubDetail>(
    { url: `/api/dashboard/v1/clubs/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardClubsControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/clubs/${id}`] as const;
};

export const getDashboardClubsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
  TError = ErrorType<
    | DashboardClubsControllerDetail400
    | DashboardClubsControllerDetail401
    | DashboardClubsControllerDetail404
    | DashboardClubsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>> = ({
    signal,
  }) => dashboardClubsControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerDetail>>
>;
export type DashboardClubsControllerDetailQueryError = ErrorType<
  | DashboardClubsControllerDetail400
  | DashboardClubsControllerDetail401
  | DashboardClubsControllerDetail404
  | DashboardClubsControllerDetail429
>;

export function useDashboardClubsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
  TError = ErrorType<
    | DashboardClubsControllerDetail400
    | DashboardClubsControllerDetail401
    | DashboardClubsControllerDetail404
    | DashboardClubsControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
  TError = ErrorType<
    | DashboardClubsControllerDetail400
    | DashboardClubsControllerDetail401
    | DashboardClubsControllerDetail404
    | DashboardClubsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
  TError = ErrorType<
    | DashboardClubsControllerDetail400
    | DashboardClubsControllerDetail401
    | DashboardClubsControllerDetail404
    | DashboardClubsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get club detail (dashboard)
 */

export function useDashboardClubsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerDetail>>,
  TError = ErrorType<
    | DashboardClubsControllerDetail400
    | DashboardClubsControllerDetail401
    | DashboardClubsControllerDetail404
    | DashboardClubsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated member list. Filter by status (`CONFIRM` / `PENDING` / `DECLINED`). Members are returned newest-first.
 * @summary List members of a club (dashboard)
 */
export const dashboardClubsControllerMemberList = (
  id: string,
  params?: DashboardClubsControllerMemberListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubMemberList>(
    { url: `/api/dashboard/v1/clubs/${id}/members`, method: "GET", params, signal },
    options
  );
};

export const getDashboardClubsControllerMemberListQueryKey = (
  id: string,
  params?: DashboardClubsControllerMemberListParams
) => {
  return [`/api/dashboard/v1/clubs/${id}/members`, ...(params ? [params] : [])] as const;
};

export const getDashboardClubsControllerMemberListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
  TError = ErrorType<
    | DashboardClubsControllerMemberList400
    | DashboardClubsControllerMemberList401
    | DashboardClubsControllerMemberList404
    | DashboardClubsControllerMemberList429
  >,
>(
  id: string,
  params?: DashboardClubsControllerMemberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardClubsControllerMemberListQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>> = ({
    signal,
  }) => dashboardClubsControllerMemberList(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerMemberListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>
>;
export type DashboardClubsControllerMemberListQueryError = ErrorType<
  | DashboardClubsControllerMemberList400
  | DashboardClubsControllerMemberList401
  | DashboardClubsControllerMemberList404
  | DashboardClubsControllerMemberList429
>;

export function useDashboardClubsControllerMemberList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
  TError = ErrorType<
    | DashboardClubsControllerMemberList400
    | DashboardClubsControllerMemberList401
    | DashboardClubsControllerMemberList404
    | DashboardClubsControllerMemberList429
  >,
>(
  id: string,
  params: undefined | DashboardClubsControllerMemberListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerMemberList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
  TError = ErrorType<
    | DashboardClubsControllerMemberList400
    | DashboardClubsControllerMemberList401
    | DashboardClubsControllerMemberList404
    | DashboardClubsControllerMemberList429
  >,
>(
  id: string,
  params?: DashboardClubsControllerMemberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerMemberList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
  TError = ErrorType<
    | DashboardClubsControllerMemberList400
    | DashboardClubsControllerMemberList401
    | DashboardClubsControllerMemberList404
    | DashboardClubsControllerMemberList429
  >,
>(
  id: string,
  params?: DashboardClubsControllerMemberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List members of a club (dashboard)
 */

export function useDashboardClubsControllerMemberList<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>,
  TError = ErrorType<
    | DashboardClubsControllerMemberList400
    | DashboardClubsControllerMemberList401
    | DashboardClubsControllerMemberList404
    | DashboardClubsControllerMemberList429
  >,
>(
  id: string,
  params?: DashboardClubsControllerMemberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardClubsControllerMemberList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerMemberListQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Total / approved / pending / declined counts for a single club.
 * @summary Club member-status breakdown (dashboard)
 */
export const dashboardClubsControllerMembersStats = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardClubMemberStats>(
    { url: `/api/dashboard/v1/clubs/${id}/members-stats`, method: "GET", signal },
    options
  );
};

export const getDashboardClubsControllerMembersStatsQueryKey = (id: string) => {
  return [`/api/dashboard/v1/clubs/${id}/members-stats`] as const;
};

export const getDashboardClubsControllerMembersStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
  TError = ErrorType<
    | DashboardClubsControllerMembersStats400
    | DashboardClubsControllerMembersStats401
    | DashboardClubsControllerMembersStats404
    | DashboardClubsControllerMembersStats429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardClubsControllerMembersStatsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>
  > = ({ signal }) => dashboardClubsControllerMembersStats(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardClubsControllerMembersStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>
>;
export type DashboardClubsControllerMembersStatsQueryError = ErrorType<
  | DashboardClubsControllerMembersStats400
  | DashboardClubsControllerMembersStats401
  | DashboardClubsControllerMembersStats404
  | DashboardClubsControllerMembersStats429
>;

export function useDashboardClubsControllerMembersStats<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
  TError = ErrorType<
    | DashboardClubsControllerMembersStats400
    | DashboardClubsControllerMembersStats401
    | DashboardClubsControllerMembersStats404
    | DashboardClubsControllerMembersStats429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerMembersStats<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
  TError = ErrorType<
    | DashboardClubsControllerMembersStats400
    | DashboardClubsControllerMembersStats401
    | DashboardClubsControllerMembersStats404
    | DashboardClubsControllerMembersStats429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardClubsControllerMembersStats<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
  TError = ErrorType<
    | DashboardClubsControllerMembersStats400
    | DashboardClubsControllerMembersStats401
    | DashboardClubsControllerMembersStats404
    | DashboardClubsControllerMembersStats429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Club member-status breakdown (dashboard)
 */

export function useDashboardClubsControllerMembersStats<
  TData = Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
  TError = ErrorType<
    | DashboardClubsControllerMembersStats400
    | DashboardClubsControllerMembersStats401
    | DashboardClubsControllerMembersStats404
    | DashboardClubsControllerMembersStats429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardClubsControllerMembersStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardClubsControllerMembersStatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Flip the club between ACTIVE and INACTIVE. Writes an audit row. Returns the updated list-row shape so the FE can patch the row in place.
 * @summary Update club lifecycle status (dashboard)
 */
export const dashboardClubsControllerUpdateStatus = (
  id: string,
  dashboardClubStatusUpdate: BodyType<DashboardClubStatusUpdate>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardClubListItem>(
    {
      url: `/api/dashboard/v1/clubs/${id}/status`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardClubStatusUpdate,
    },
    options
  );
};

export const getDashboardClubsControllerUpdateStatusMutationOptions = <
  TError = ErrorType<
    | DashboardClubsControllerUpdateStatus400
    | DashboardClubsControllerUpdateStatus401
    | DashboardClubsControllerUpdateStatus404
    | DashboardClubsControllerUpdateStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>,
    TError,
    { id: string; data: BodyType<DashboardClubStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>,
  TError,
  { id: string; data: BodyType<DashboardClubStatusUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>,
    { id: string; data: BodyType<DashboardClubStatusUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardClubsControllerUpdateStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardClubsControllerUpdateStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>
>;
export type DashboardClubsControllerUpdateStatusMutationBody = BodyType<DashboardClubStatusUpdate>;
export type DashboardClubsControllerUpdateStatusMutationError = ErrorType<
  | DashboardClubsControllerUpdateStatus400
  | DashboardClubsControllerUpdateStatus401
  | DashboardClubsControllerUpdateStatus404
  | DashboardClubsControllerUpdateStatus429
>;

/**
 * @summary Update club lifecycle status (dashboard)
 */
export const useDashboardClubsControllerUpdateStatus = <
  TError = ErrorType<
    | DashboardClubsControllerUpdateStatus400
    | DashboardClubsControllerUpdateStatus401
    | DashboardClubsControllerUpdateStatus404
    | DashboardClubsControllerUpdateStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>,
    TError,
    { id: string; data: BodyType<DashboardClubStatusUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateStatus>>,
  TError,
  { id: string; data: BodyType<DashboardClubStatusUpdate> },
  TContext
> => {
  const mutationOptions = getDashboardClubsControllerUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Set the member to CONFIRM / PENDING / DECLINED. Mirrors the legacy GraphQL `updateClubMember` side effects: stamps `approvedAt` on confirm and fires the accept/decline email when the club has email enabled.
 * @summary Update club member approval status (dashboard)
 */
export const dashboardClubsControllerUpdateMemberStatus = (
  clubId: string,
  memberId: number,
  dashboardClubMemberStatusUpdateInput: BodyType<DashboardClubMemberStatusUpdateInput>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardClubMemberStatusUpdate>(
    {
      url: `/api/dashboard/v1/clubs/${clubId}/members/${memberId}/status`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardClubMemberStatusUpdateInput,
    },
    options
  );
};

export const getDashboardClubsControllerUpdateMemberStatusMutationOptions = <
  TError = ErrorType<
    | DashboardClubsControllerUpdateMemberStatus400
    | DashboardClubsControllerUpdateMemberStatus401
    | DashboardClubsControllerUpdateMemberStatus404
    | DashboardClubsControllerUpdateMemberStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>,
    TError,
    { clubId: string; memberId: number; data: BodyType<DashboardClubMemberStatusUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>,
  TError,
  { clubId: string; memberId: number; data: BodyType<DashboardClubMemberStatusUpdateInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>,
    { clubId: string; memberId: number; data: BodyType<DashboardClubMemberStatusUpdateInput> }
  > = (props) => {
    const { clubId, memberId, data } = props ?? {};

    return dashboardClubsControllerUpdateMemberStatus(clubId, memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardClubsControllerUpdateMemberStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>
>;
export type DashboardClubsControllerUpdateMemberStatusMutationBody =
  BodyType<DashboardClubMemberStatusUpdateInput>;
export type DashboardClubsControllerUpdateMemberStatusMutationError = ErrorType<
  | DashboardClubsControllerUpdateMemberStatus400
  | DashboardClubsControllerUpdateMemberStatus401
  | DashboardClubsControllerUpdateMemberStatus404
  | DashboardClubsControllerUpdateMemberStatus429
>;

/**
 * @summary Update club member approval status (dashboard)
 */
export const useDashboardClubsControllerUpdateMemberStatus = <
  TError = ErrorType<
    | DashboardClubsControllerUpdateMemberStatus400
    | DashboardClubsControllerUpdateMemberStatus401
    | DashboardClubsControllerUpdateMemberStatus404
    | DashboardClubsControllerUpdateMemberStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>,
    TError,
    { clubId: string; memberId: number; data: BodyType<DashboardClubMemberStatusUpdateInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardClubsControllerUpdateMemberStatus>>,
  TError,
  { clubId: string; memberId: number; data: BodyType<DashboardClubMemberStatusUpdateInput> },
  TContext
> => {
  const mutationOptions = getDashboardClubsControllerUpdateMemberStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
